import React from "react";

const Plateforme = () => (
  <section className="mk-section" id="plateforme" data-testid="section-plateforme">
    <div className="mk-wrap">
      <div className="mk-section-head mk-reveal">
        <div>
          <h2 className="mk-outline-title">Les bons profils existent. Ils sont juste difficiles à mobiliser au bon moment.</h2>
        </div>
      </div>
      <div className="mk-challenge mk-reveal">
        <article className="mk-problem">
          <span className="mk-tag">sans ASAP Hub</span>
          <h3>Recrutement lent et risque de se faire devancer par la concurrence</h3>
          <div className="mk-checklist">
            <div className="mk-check"><i aria-hidden="true" /><span>La recherche est trop manuelle.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Le vivier est sous-exploité.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Les CV reçus sont difficiles à prioriser.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Les réponses candidats prennent du temps.</span></div>
          </div>
        </article>
        <article className="mk-solution">
          <span className="mk-tag">Avec ASAP Hub</span>
          <h3>ASAP Hub accélère le sourcing et fluidifie le recrutement.</h3>
          <div className="mk-checklist">
            <div className="mk-check"><i aria-hidden="true" /><span>Activation plus rapide du vivier existant.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Score automatique des CV reçus.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Priorisation des meilleurs candidats.</span></div>
            <div className="mk-check"><i aria-hidden="true" /><span>Automatisation des réponses candidats.</span></div>
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default Plateforme;
